"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const sharedUtils_1 = require("src/utils/sharedUtils");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const AppNavHeader_1 = __importDefault(require("src/components/organisms/AppNavHeader"));
const AppTable_1 = __importDefault(require("src/components/organisms/AppTable"));
const ProjectSettings_module_css_1 = __importDefault(require("./styles/ProjectSettings.module.css"));
const selectors_1 = require("src/stores/applicationStore/auth/selectors");
const selectors_2 = require("src/stores/applicationStore/users/selectors");
const thunk_1 = require("src/stores/applicationStore/users/thunk");
const InviteUserModal_1 = __importDefault(require("./modals/InviteUserModal"));
const EmptyBlock_1 = __importDefault(require("src/components/molecules/EmptyBlock"));
const SVGHoverable_1 = __importDefault(require("src/components/organisms/SVGHoverable"));
const Remove_1 = __importDefault(require("src/components/svg/Remove"));
const Users = () => {
    const [showInviteUserModal, setInviteUserModal] = (0, react_1.useState)(false);
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const users = (0, reduxHooks_1.useAppSelector)(selectors_2.selectUsers);
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    const [canAdd, canRemove] = (0, react_1.useMemo)(() => {
        return [
            (0, sharedUtils_1.access)({ profile: me, section: "users", permission: "add" }),
            (0, sharedUtils_1.access)({ profile: me, section: "users", permission: "delete" }),
        ];
    }, [me]);
    const fetchData = () => {
        dispatch((0, thunk_1.fetchUsersThunk)());
    };
    const onRemove = (id) => {
        if (confirm(i18n_1.default.t("Are_you_sure_you_want_delete_record"))) {
            dispatch((0, thunk_1.removeUserThunk)(id));
        }
    };
    const handleInviteUser = () => {
        setInviteUserModal(true);
    };
    const renderHead = () => {
        return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: i18n_1.default.t("User") }), (0, jsx_runtime_1.jsx)("th", { children: i18n_1.default.t("Permissions_") }), (0, jsx_runtime_1.jsx)("th", { style: { width: "75px" } })] }));
    };
    const renderBody = () => {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: users.map((user) => ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: user.user.email }), (0, jsx_runtime_1.jsx)("td", { children: i18n_1.default.t("Permission_level")[user.user_role] }), (0, jsx_runtime_1.jsx)("td", { children: !!canRemove && user.user.id != me.id && ((0, jsx_runtime_1.jsx)(SVGHoverable_1.default, Object.assign({ styles: { padding: 7 }, hoverColor: "var(--color-black)", onClick: () => onRemove(user.id) }, { children: Remove_1.default }))) })] }, user.id))) }));
    };
    (0, react_1.useEffect)(() => {
        fetchData();
    }, []);
    if (!me || users === null) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: ProjectSettings_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("Users") }), (0, jsx_runtime_1.jsx)(EmptyBlock_1.default, { title: i18n_1.default.t("Loading") })] })));
    }
    if (users.length === 0) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: ProjectSettings_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("Users") }), (0, jsx_runtime_1.jsx)(EmptyBlock_1.default, { title: i18n_1.default.t("no users") })] })));
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: ProjectSettings_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("Users"), button: !!canAdd && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ style: { marginLeft: "10px" }, onClick: handleInviteUser }, { children: i18n_1.default.t("Invite") }))) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: ProjectSettings_module_css_1.default.content }, { children: (0, jsx_runtime_1.jsx)(AppTable_1.default, { renderHead: renderHead, renderBody: renderBody }) }))] })), (0, jsx_runtime_1.jsx)(InviteUserModal_1.default, { show: showInviteUserModal, setShow: setInviteUserModal })] }));
};
exports.default = Users;
